import React from 'react'
import SkyLight from 'react-skylight'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { getToken } from '../Commons/Authentication'
import MiddleLine from '../../img/icons/general-icons/separator_icon.png'
import _ from 'lodash'
import AlergiasImage from '../../img/special-conditions/alergias.png'
import AnticuagImage from '../../img/special-conditions/anticuagulado.png'
import ControlPImage from '../../img/special-conditions/control_peso.png'
import CuidadoEImage from '../../img/special-conditions/cuidado_especial.png'
import DiabeticoImage from '../../img/special-conditions/diabetico.png'
import FaseIIImage from '../../img/special-conditions/fase2.png'
import FragilImage from '../../img/special-conditions/fragil.png'
import InactivoImage from '../../img/special-conditions/inactivo.png'
import OxigenoImage from '../../img/special-conditions/oxigeno_dependiente.png'
import ProgramaDImage from '../../img/special-conditions/programa_domiciliario.png'
import ReingresoImage from '../../img/special-conditions/reingreso.png'
import SaturacionImage from '../../img/special-conditions/saturacion_o2.png'

export default class SpecialConditionsComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({
      patient: null,
      /* States para almacenar en base de datos */
      saturacion: false,
      oxigeno: false,
      diabetico: false,
      fragil: false,
      estado: false,
      fase2: false,
      cuidadoE: false,
      anticuagulado: false,
      controlPeso: false,
      reingreso: false,
      programaD: false,
      alergias: false,
      showAlergInput: false,
      textAlergias: '',
      /* Manejos de clases */
      saturacionClass: 'condition-content', oxigenoClass: 'condition-content', diabeticoClass: 'condition-content',
      fragilClass: 'condition-content', estadoClass: 'condition-content', fase2Class: 'condition-content', cuidadoEClass: 'condition-content',
      anticuaguladoClass: 'condition-content', controlPesoClass: 'condition-content', reingresoClass: 'condition-content',
      programaDClass: 'condition-content', alergiasClass: 'condition-content', showAlergInputClass: 'condition-content'
    })
  }

  componentWillMount () {
    let identification = this.props.data
    if (identification) {
      let endpoint = `api/v1/patient/find?numeroDocumento=${identification}`
      request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (!_.isEmpty(res.body[0])) {
          let paciente = res.body[0]
          this.setState({
            patient: paciente,
            saturacion: paciente.saturacion,
            oxigeno: paciente.oxigeno,
            diabetico: paciente.diabetico,
            fragil: paciente.fragil,
            estado: paciente.estado,
            fase2: paciente.fase2,
            cuidadoE: paciente.cuidadoE,
            anticuagulado: paciente.anticuagulado,
            controlPeso: paciente.controlPeso,
            reingreso: paciente.reingreso,
            programaD: paciente.programaD,
            alergias: paciente.alergias,
            showAlergInput: paciente.alergias,
            textAlergias: paciente.textAlergias,

            saturacionClass: (paciente.saturacion === true) ? 'condition-content condition-content-checked' : 'condition-content',
            oxigenoClass: (paciente.oxigeno === true) ? 'condition-content condition-content-checked' : 'condition-content',
            diabeticoClass: (paciente.diabetico === true) ? 'condition-content condition-content-checked' : 'condition-content',
            fragilClass: (paciente.fragil === true) ? 'condition-content condition-content-checked' : 'condition-content',

            estadoClass: (paciente.estado === true) ? 'condition-content condition-content-checked' : 'condition-content',
            fase2Class: (paciente.fase2 === true) ? 'condition-content condition-content-checked' : 'condition-content',
            cuidadoEClass: (paciente.cuidadoE === true) ? 'condition-content condition-content-checked' : 'condition-content',
            anticuaguladoClass: (paciente.anticuagulado === true) ? 'condition-content condition-content-checked' : 'condition-content',

            controlPesoClass: (paciente.controlPeso === true) ? 'condition-content condition-content-checked' : 'condition-content',
            reingresoClass: (paciente.reingreso === true) ? 'condition-content condition-content-checked' : 'condition-content',
            programaDClass: (paciente.programaD === true) ? 'condition-content condition-content-checked' : 'condition-content',
            alergiasClass: (paciente.alergias === true) ? 'condition-content condition-content-checked' : 'condition-content'
          })
        } else if (err) {
          console.log('Se encontraron errores')
        }
      })
    }
  }

  toggleSaturacion () {
    this.setState({
      saturacion: !this.state.saturacion,
      saturacionClass: (this.state.saturacionClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleOxigenoDe () {
    this.setState({
      oxigeno: !this.state.oxigeno,
      oxigenoClass: (this.state.oxigenoClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleAnticuagu () {
    this.setState({
      anticuagulado: !this.state.anticuagulado,
      anticuaguladoClass: (this.state.anticuaguladoClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
    console.log('El anticuagulado', this.state.anticuagulado)
  }

  toggleDiabetico () {
    this.setState({
      diabetico: !this.state.diabetico,
      diabeticoClass: (this.state.diabeticoClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleCuidadoEs () {
    this.setState({
      cuidadoE: !this.state.cuidadoE,
      cuidadoEClass: (this.state.cuidadoEClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleControlPe () {
    this.setState({
      controlPeso: !this.state.controlPeso,
      controlPesoClass: (this.state.controlPesoClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleFase2Stat () {
    this.setState({
      fase2: !this.state.fase2,
      fase2Class: (this.state.fase2Class === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleReingreso () {
    this.setState({
      reingreso: !this.state.reingreso,
      reingresoClass: (this.state.reingresoClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleProgramaD () {
    this.setState({
      programaD: !this.state.programaD,
      programaDClass: (this.state.programaDClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleFragilPte () {
    this.setState({
      fragil: !this.state.fragil,
      fragilClass: (this.state.fragilClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleAlergiasP () {
    this.setState({
      alergias: !this.state.alergias,
      alergiasClass: (this.state.alergiasClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  toggleEstado () {
    this.setState({
      estado: !this.state.estado,
      estadoClass: (this.state.estadoClass === 'condition-content condition-content-checked') ? 'condition-content' : 'condition-content condition-content-checked'
    })
  }

  inputChange () {
    this.setState({ textAlergias: this.refs.textAlergias.value })
  }

  submitSpecial () {
    this.props.onSaveSpecial(this.state)
    this.props.showTextBoxParent(this.state)
    this.refs.conditionsDialog.hide()
  }

  render () {
    var settings = {
      backgroundColor: '#1A3B4E',
      color: '#ffffff',
      width: '50%',
      height: 'auto',
      border: '1px solid #FFFFFF',
      fontSize: '14px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }

    return (
      <div className='conditions-container'>
        <div className='special-conditions' onClick={() => this.refs.conditionsDialog.show()}>Marcaciones</div>
        <SkyLight dialogStyles={settings} ref='conditionsDialog' hideOnOverlayClicked title='Marcaciones'>
          <div className='special-conditions-container'>
            <div className='conditions-row'>
              <div className={this.state.saturacionClass} onClick={this.toggleSaturacion.bind(this)}>
                <img src={SaturacionImage}/>
                <span className='condition-text'>Saturación O2</span>
              </div>
              <div className={this.state.oxigenoClass} onClick={this.toggleOxigenoDe.bind(this)}>
                <img src={OxigenoImage}/>
                <div className='condition-text text-lines'>
                  <span>Oxigeno</span>
                  <span>dependiente</span>
                </div>
              </div>
              <div className={this.state.diabeticoClass} onClick={this.toggleDiabetico.bind(this)}>
                <img src={DiabeticoImage}/>
                <span className='condition-text'>Diabético</span>
              </div>
              <div className={this.state.fragilClass} onClick={this.toggleFragilPte.bind(this)}>
                <img src={FragilImage}/>
                <span className='condition-text'>Frágil</span>
              </div>
            </div>

            <div className='conditions-row'>
              <div className={this.state.estadoClass} onClick={this.toggleEstado.bind(this)}>
                <img src={InactivoImage}/>
                <span className='condition-text'>Inactivo</span>
              </div>
              <div className={this.state.fase2Class} onClick={this.toggleFase2Stat.bind(this)}>
                <img src={FaseIIImage}/>
                <span className='condition-text'>Fase II</span>
              </div>
              <div className={this.state.cuidadoEClass} onClick={this.toggleCuidadoEs.bind(this)}>
                <img src={CuidadoEImage}/>
                <span className='condition-text'>Cuidado especial</span>
              </div>
              <div className={this.state.anticuaguladoClass} onClick={this.toggleAnticuagu.bind(this)}>
                <img src={AnticuagImage}/>
                <span className='condition-text'>Anticuagulado</span>
              </div>
            </div>

            <div className='conditions-row'>
              <div className={this.state.controlPesoClass} onClick={this.toggleControlPe.bind(this)}>
                <img src={ControlPImage}/>
                <span className='condition-text'>Control de peso</span>
              </div>
              <div className={this.state.reingresoClass} onClick={this.toggleReingreso.bind(this)}>
                <img src={ReingresoImage}/>
                <span className='condition-text'>Reingreso</span>
              </div>
              <div className={this.state.programaDClass} onClick={this.toggleProgramaD.bind(this)}>
                <img src={ProgramaDImage}/>
                <div className='condition-text text-lines'>
                  <span>Programa</span>
                  <span>domiciliario</span>
                </div>
              </div>
              <div className={this.state.alergiasClass} onClick={this.toggleAlergiasP.bind(this)}>
                <img src={AlergiasImage}/>
                <span className='condition-text'>Alergias</span>
              </div>
            </div>
          </div>
          { (this.state.alergias === true) ? <div className='alerg-container'>
            <div className='text-alerg'>
              <span>Alérgico a:</span>
            </div>
             <input type='text' ref='textAlergias' id='textAlergias' className='alergic-input' name='textAlergias' value={this.state.textAlergias} placeholder='Ingrese las alergias que presenta separadas por coma' onChange={this.inputChange.bind(this)}/>
           </div> : null }
         <div className='form-submit-btn-container btn-conditions'>
           <div id='Conditions' className='form-submit-button add-special-conditions' onClick={this.submitSpecial.bind(this)}>Agregar marcaciones</div>
         </div>
        </SkyLight>
      </div>
    )
  }
}

SpecialConditionsComponent.propTypes = {
  onSaveSpecial: React.PropTypes.func,
  showTextBoxParent: React.PropTypes.func,
  data: React.PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Patient/SpecialConditions.js